import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Login from "./pages/Login";
import Start from "./pages/start";
import Welcome from "./pages/Welcome";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import Main from "./pages/Main";
import Combined from "./pages/Combined";
import Documents from "./pages/Documents";
import Roi from "./pages/Roi";
import Client from "./pages/Client";
import MainContacts from "./pages/MainContacts";
import MainClients from "./pages/MainClients";
import NewClients from "./pages/NewClients";
import ExistingClients from "./pages/ExistingClients";
import Charts from "./pages/Charts";
import ExistingClientsChart from "./pages/ExistingClientsChart";
import Register from "./pages/Register";
import AdvisorRegister from "./pages/AdvisorRegister";
import EndUserRegister from "./pages/EndUserRegister";
import AddClient from "./pages/AddClient";
import Assessments from "./pages/Assessments";
import AddAssessments from "./pages/AddAssessments";
import InterviewSetup from "./pages/InterviewSetup";
import ActiveAssessments from "./pages/ActiveAssessments";
import UploadInterviews from "./pages/UploadInterviews";
import AssessmentProgress from "./pages/AssessmentProgress";
import AssessmentFindings from "./pages/AssessmentFindings";

import LearnMoreAboutUs from "./pages/LearAboutUs";
import PricingNew from "./pages/PricingNew";
import LoginNew from "./pages/LoginNew";
import RegisterNew from "./pages/RegisterNew";
import DashboardNew from "./pages/DashboardNew";
import AddAssessmentsNew from "./pages/AddAssessmentsNew";
import AssessmentsNew from "./pages/AssessmentsNew";
import InterviewSetupNew from "./pages/InterviewSetupNew";
import Training from "./pages/Training";
import AiAcademy from "./pages/AiAcademy";
import ActiveAssessmentsNew from "./pages/ActiveAssessmentsNew";
import CompletedAssessmentsNew from "./pages/CompletedAssessmentsNew";
import WhiteLableDoc from "./pages/WhiteLableDoc";
import Settings from "./pages/Settings";

import LoginNewV1 from "./pages/LoginNewV1";
import DashboardNewV1 from "./pages/DashboardNewV1";
import AssessmentsNewV1 from "./pages/AssessmentsNewV1";
import AssessmentNewV1 from "./pages/AssessmentNewV1";
import DocumentsNewV1 from "./pages/DocumentsNewV1";
import EducationNewV1 from "./pages/EducationNewV1";
import ChatboNewV1 from "./pages/ChatbotNewV1";
import SettingsNewV1 from "./pages/SettingsNewV1";
import CalendarNewV1 from "./pages/CalendarNewV1";
import { AssessmentProvider } from "./contexts/AssessmentContext";
import Admin from "./pages/Admin";
import CheckoutResult from "./pages/CheckoutResult";

function App() {
  return (
    <LanguageProvider>
      <AssessmentProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LoginNewV1 />} />
            <Route path="/dashboard" element={<DashboardNewV1 />} />
            <Route path="/checkout-result" element={<CheckoutResult />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/assessments" element={<AssessmentsNewV1 />} />
            <Route
              path="/assessment/:assessmentId"
              element={<AssessmentNewV1 />}
            />
            <Route path="/documents" element={<DocumentsNewV1 />} />
            {/* <Route path="/education" element={<EducationNewV1 />} /> */}
            {/* <Route path="/chatbot" element={<ChatboNewV1 />} /> */}
            <Route path="/settings" element={<SettingsNewV1 />} />
            {/* <Route path="/calendar" element={<CalendarNewV1 />} /> */}
            {/* <Route path="/" element={<Start />}>
              <Route path="learnAboutUs" element={<LearnMoreAboutUs />} />
              <Route path="pricing" element={<PricingNew />} />
              <Route path="login" element={<LoginNewV1 />} />
              <Route path="register" element={<RegisterNew />} />
            </Route> */}
            {/* <Route path="/dashboard" element={<DashboardNewV1 />}>
              <Route path="addAssessments" element={<AddAssessmentsNew />} />
              <Route path="assessments" element={<AssessmentsNew />} />
              <Route path="training" element={<Training />} />
              <Route path="aiacademy" element={<AiAcademy />} />
              <Route
                path="activeAssessments"
                element={<ActiveAssessmentsNew />}
              />
              <Route
                path="completedAssessments"
                element={<CompletedAssessmentsNew />}
              />

              <Route
                path=":company/interviewSetup"
                element={<InterviewSetupNew />}
              />
              <Route path="settings" element={<Settings />} />
              <Route path="whiteLableDoc" element={<WhiteLableDoc />} />
            </Route> */}
            {/* <Route path="/welcome" element={<Welcome />} />

            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />}>
              <Route path="register" element={<Register />}>
                <Route path="advisorRegister" element={<AdvisorRegister />} />
                <Route path="endUserRegister" element={<EndUserRegister />} />
              </Route>

              <Route path="addClient" element={<AddClient />} />
              <Route path="assessments" element={<Assessments />}>
                <Route path="addAssessments" element={<AddAssessments />} />
              </Route>
              <Route path="activeAssessments" element={<ActiveAssessments />}>
                <Route
                  path=":company/interviewSetup"
                  element={<InterviewSetup />}
                />
                <Route
                  path=":company/uploadInterviews"
                  element={<UploadInterviews />}
                />
                <Route
                  path=":company/assessmentFindings"
                  element={<AssessmentFindings />}
                />
                <Route
                  path=":company/assessmentProgress"
                  element={<AssessmentProgress />}
                />
              </Route>
              <Route path="main" element={<Main />}>
                <Route path="combined-result" element={<Combined />} />
                <Route path="documents" element={<Documents />} />
                <Route path="roi" element={<Roi />} />
                <Route path="client" element={<Client />} />
              </Route>
              <Route path="clients" element={<MainClients />}>
                <Route path="contact" element={<MainContacts />}>
                  <Route path="new-clients" element={<NewClients />} />
                  <Route path="existing-clients" element={<ExistingClients />} />
                </Route>
                <Route path="charts" element={<Charts />}>
                  <Route
                    path="existing-clients-chart"
                    element={<ExistingClientsChart />}
                  />
                </Route>
              </Route>
            </Route> */}
          </Routes>
        </Router>
      </AssessmentProvider>
    </LanguageProvider>
  );
}

export default App;
